const DOCUMENT_TYPE_IDS = {
    RIDESHARE_PLATFORM_PROOF: {
        production: "SW5jaWRlbnREb2N1bWVudFR5cGVOb2RlOjg=",
        staging: "SW5jaWRlbnREb2N1bWVudFR5cGVOb2RlOjc=",
        development: "SW5jaWRlbnREb2N1bWVudFR5cGVOb2RlOjEy",
    },
    POLICE_REPORT: {
        production: "SW5jaWRlbnREb2N1bWVudFR5cGVOb2RlOjk=",
        staging: "SW5jaWRlbnREb2N1bWVudFR5cGVOb2RlOjg=",
        development: "SW5jaWRlbnREb2N1bWVudFR5cGVOb2RlOjEz",
    },
    DAR: {
        production: "SW5jaWRlbnREb2N1bWVudFR5cGVOb2RlOjM=",
        staging: "SW5jaWRlbnREb2N1bWVudFR5cGVOb2RlOjk=",
        development: "SW5jaWRlbnREb2N1bWVudFR5cGVOb2RlOjE0",
    },
    DASH_CAM_VIDEO: {
        production: "SW5jaWRlbnREb2N1bWVudFR5cGVOb2RlOjEw",
        staging: "SW5jaWRlbnREb2N1bWVudFR5cGVOb2RlOjEw",
        development: "SW5jaWRlbnREb2N1bWVudFR5cGVOb2RlOjE1",
    },
};

const getDocumentTypeId = (type) => DOCUMENT_TYPE_IDS[type][process.env.NODE_ENV || "development"];

export const getMissingTaskCount = (incident) => {
    if (!incident) return 0;
    const node = incident.node || incident;
    const docs = node?.incidentdocumentSet?.edges?.map(e => e.node) || [];
    let missingCount = 0;

    const stateCode = node?.branch?.stateCode || null;
    const isRSN = stateCode !== "NY";
    if (node?.hasPoliceReport === 'YES' && !docs.some(doc => doc.documentType?.id === getDocumentTypeId("POLICE_REPORT"))) missingCount++;
    if (node?.hasDashcamVideos === 'YES' && !docs.some(doc => doc.documentType?.id === getDocumentTypeId("DASH_CAM_VIDEO"))) missingCount++;
    if (node?.hasOtherParties === 'YES' && !(node?.incidentpartySet?.edges?.length > 0)) missingCount++;
    if (((node?.hasOtherParties === 'YES' && isRSN) || !isRSN) && !node?.isRecordOnly && !docs.some(doc => doc?.documentType?.id === getDocumentTypeId("DAR"))) missingCount++;
    if (!!node?.rental && !node?.carCondition) missingCount++;
    if (node?.ridesharePlatform && node?.ridesharePeriodSource !== "ARGYLE_VERIFIED") {
        if (!docs.some(doc => doc.documentType?.id === getDocumentTypeId("RIDESHARE_PLATFORM_PROOF"))) missingCount++;
    }
    if (node?.liabilityclaimSet?.edges?.length > 0) {
        if (node.liabilityclaimSet.edges.some(claim => !claim.node.externalId)) missingCount++;
    }
    return missingCount;
};


const getVisibleTasks = (node) => {
    const visible = [];
    if (node?.hasPoliceReport === 'YES') visible.push('policeReport');
    if (node?.hasDashcamVideos === 'YES') visible.push('dashcam');
    if (node?.hasOtherParties === 'YES') visible.push('otherParty');
    const isRSN = node?.branch?.stateCode !== "NY";
    if (((node?.hasOtherParties === 'YES' && isRSN) || !isRSN) && !node?.isRecordOnly) visible.push('dar');
    if (!!node?.rental) visible.push('carInspection');
    if (node?.ridesharePlatform && node?.ridesharePeriodSource !== "ARGYLE_VERIFIED") visible.push('rideshareProof');
    if (node?.liabilityclaimSet?.edges?.length > 0) visible.push('liabilityClaim');
    return visible;
};

export const renderTasks = (incident) => {
    if (!incident) return null;
    const node = incident.node || incident;
    const docs = node?.incidentdocumentSet?.edges?.map(e => e.node) || [];
    const policeReportDoc = docs.some(doc => doc.documentType?.id === getDocumentTypeId("POLICE_REPORT"));
    const dashcamDoc = docs.some(doc => doc.documentType?.id === getDocumentTypeId("DASH_CAM_VIDEO"));
    const darDoc = docs.some(doc => doc.documentType?.id === getDocumentTypeId("DAR"));
    const carInspection = !!node?.rental && !!node?.carCondition;
    const liabilityClaimMissingExternalId = node?.liabilityclaimSet?.edges?.some(claim => !claim.node.externalId);

    const statusBadge = (ok) => (
        <p className="mb-0" style={{ fontSize: 11, color: ok ? "green" : "red" }}>{ok ? "COMPLETED" : "PENDING"}</p>
    );

    const visibleTasks = getVisibleTasks(node);

    if (visibleTasks.length === 0) {
        return (
            <tr>
                <td style={{ padding: "16px", fontWeight: 500 }}>
                    <p className="mb-0">No tasks are currently required for this incident based on the available information.</p>
                </td>
            </tr>
        );
    }

    return (
        <>
            {visibleTasks.includes('policeReport') && (
                <tr>
                    <td>Police Report</td>
                    <td>{statusBadge(policeReportDoc)}</td>
                </tr>
            )}
            {visibleTasks.includes('dashcam') && (
                <tr>
                    <td>Dashcam Video</td>
                    <td>{statusBadge(dashcamDoc)}</td>
                </tr>
            )}
            {visibleTasks.includes('otherParty') && (
                <tr>
                    <td>Other Party Exists</td>
                    <td>{statusBadge(node?.incidentpartySet?.edges?.length > 0)}</td>
                </tr>
            )}
            {visibleTasks.includes('dar') && (
                <tr>
                    <td>DAR</td>
                    <td>{statusBadge(darDoc)}</td>
                </tr>
            )}
            {visibleTasks.includes('carInspection') && (
                <tr>
                    <td>Car Inspection</td>
                    <td>{statusBadge(carInspection)}</td>
                </tr>
            )}
            {visibleTasks.includes('rideshareProof') && (
                <tr>
                    <td>Rideshare Platform Proof</td>
                    <td>{statusBadge(!!docs.some(doc => doc.documentType?.id === getDocumentTypeId("RIDESHARE_PLATFORM_PROOF")))}</td>
                </tr>
            )}
            {visibleTasks.includes('liabilityClaim') && (
                <tr>
                    <td>Liability Claim External ID</td>
                    <td>{statusBadge(!liabilityClaimMissingExternalId)}</td>
                </tr>
            )}
        </>
    );
};
